import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

export function useDashboard() {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => (await api.get("/dashboard")).data,
  });
}

export function useDashboardActions() {
  const qc = useQueryClient();
  const invalidate = () => qc.invalidateQueries({ queryKey: ["dashboard"] });
  return {
    setAgentStatus: async (id, status) => { await api.patch(`/agents/${id}/status`, { status }); await invalidate(); },
    setWalletStatus: async (id, status) => { await api.patch(`/wallets/${id}/status`, { status }); await invalidate(); },
    setTxnStatus: async (id, status) => { await api.patch(`/transactions/${id}/status`, { status }); await invalidate(); },
    decideApproval: async (id, decision) => { await api.patch(`/approvals/${id}`, { decision }); await invalidate(); },
    togglePolicy: async (id) => { await api.patch(`/policies/${id}/toggle`); await invalidate(); },

    createAgent: async (body) => { await api.post("/agents", body); await invalidate(); },
    updateAgent: async (id, body) => { await api.put(`/agents/${id}`, body); await invalidate(); },
    deleteAgent: async (id) => { await api.delete(`/agents/${id}`); await invalidate(); },

    createWallet: async (body) => { await api.post("/wallets", body); await invalidate(); },
    updateWallet: async (id, body) => { await api.put(`/wallets/${id}`, body); await invalidate(); },
    deleteWallet: async (id) => { await api.delete(`/wallets/${id}`); await invalidate(); },

    createPolicy: async (body) => { await api.post("/policies", body); await invalidate(); },
    updatePolicy: async (id, body) => { await api.put(`/policies/${id}`, body); await invalidate(); },
    deletePolicy: async (id) => { await api.delete(`/policies/${id}`); await invalidate(); },

    createTransaction: async (body) => { await api.post("/transactions", body); await invalidate(); },
    updateTransaction: async (id, body) => { await api.put(`/transactions/${id}`, body); await invalidate(); },
    deleteTransaction: async (id) => { await api.delete(`/transactions/${id}`); await invalidate(); },
  };
}
